// @generated by TypeGen from NMEA/N2K/N2KEntry.swift - DO NOT EDIT

import type { IAISShipType } from "../AIS/AISLookups"
import type { INMEASource } from "../NMEAEntry"
import type { IN2KAGSGeneratingState, IN2KAGSMode, IN2KAGSOffReason, IN2KAGSOnReason, IN2KAGSOperatingState, IN2KAlertCategory, IN2KAlertResponseCommand, IN2KAlertState, IN2KAlertThresholdStatus, IN2KAlertTriggerCondition, IN2KAlertType, IN2KBatteryChemistry, IN2KBatteryNominalVoltage, IN2KBatteryType, IN2KChargerMode, IN2KChargerState, IN2KDCType, IN2KDSCCategory, IN2KDirectionReference, IN2KDockingStatus, IN2KGearStatus, IN2KInverterMode, IN2KInverterState, IN2KOffOn, IN2KRodeType, IN2KRudderDirection, IN2KSteeringMode, IN2KTankType, IN2KTurnMode, IN2KWindReference, IN2KWindlassDirection, IN2KWindlassMotion, IN2KYesNo } from "./N2KLookups"

export interface IN2KAGSConfiguration extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  generatorInstance?: number;
  mode?: IN2KAGSMode;
}

export interface IN2KAGSStatus extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  generatorInstance?: number;
  operatingState?: IN2KAGSOperatingState;
  generatorState?: IN2KAGSGeneratingState;
  onReason?: IN2KAGSOnReason;
  offReason?: IN2KAGSOffReason;
}

export interface IN2KAISAddressedSafetyMessage extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  sourceMmsi: number;
  destinationMmsi?: number;
  text?: string;
}

export interface IN2KAISClassAStatic extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  mmsi: number;
  imoNumber?: number;
  callsign?: string;
  name?: string;
  shipType?: IAISShipType;
  length?: number;
  beam?: number;
  positionReferenceFromStarboard?: number;
  positionReferenceFromBow?: number;
  eta?: string;
  draft?: number;
  destination?: string;
}

export interface IN2KAISClassBStaticPartA extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  mmsi: number;
  name?: string;
}

export interface IN2KAISClassBStaticPartB extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  mmsi: number;
  shipType?: IAISShipType;
  callsign?: string;
  length?: number;
  beam?: number;
}

export interface IN2KAISSafetyBroadcastMessage extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  sourceMmsi: number;
  text?: string;
}

export interface IN2KAISSarAircraftPosition extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  mmsi: number;
  latitude?: number;
  longitude?: number;
  cog?: number;
  sog?: number;
  altitude?: number;
}

export interface IN2KActualPressure extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  pressure: number;
}

export interface IN2KAlert extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  alertType?: IN2KAlertType;
  alertCategory?: IN2KAlertCategory;
  alertSystem?: number;
  alertSubSystem?: number;
  alertId?: number;
  acknowledgeStatus?: IN2KYesNo;
  escalationStatus?: IN2KYesNo;
  triggerCondition?: IN2KAlertTriggerCondition;
  thresholdStatus?: IN2KAlertThresholdStatus;
  alertPriority?: number;
  alertState?: IN2KAlertState;
}

export interface IN2KAlertConfiguration extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  alertType?: IN2KAlertType;
  alertCategory?: IN2KAlertCategory;
  alertSystem?: number;
  alertSubSystem?: number;
  alertId?: number;
  reactivationPeriod?: number;
  temporarySilencePeriod?: number;
  escalationPeriod?: number;
}

export interface IN2KAlertText extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  alertType?: IN2KAlertType;
  alertCategory?: IN2KAlertCategory;
  alertSystem?: number;
  alertSubSystem?: number;
  alertId?: number;
  textDescription?: string;
  locationTextDescription?: string;
}

export interface IN2KAlertThreshold extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  alertType?: IN2KAlertType;
  alertCategory?: IN2KAlertCategory;
  alertSystem?: number;
  alertSubSystem?: number;
  alertId?: number;
  parameterNumber?: number;
  thresholdLevel?: number;
}

export interface IN2KAlertValue extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  alertType?: IN2KAlertType;
  alertCategory?: IN2KAlertCategory;
  alertSystem?: number;
  alertSubSystem?: number;
  alertId?: number;
  valueParameterNumber?: number;
  valueData?: number;
}

export interface IN2KBatteryConfiguration extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  batteryType?: IN2KBatteryType;
  supportsEqualization?: IN2KYesNo;
  nominalVoltage?: IN2KBatteryNominalVoltage;
  chemistry?: IN2KBatteryChemistry;
  capacity?: number;
  temperatureCoefficient?: number;
  peukertExponent?: number;
  chargeEfficiencyFactor?: number;
}

export interface IN2KBatteryDC extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  dcType?: IN2KDCType;
  stateOfCharge?: number;
  stateOfHealth?: number;
  timeRemaining?: number;
  rippleVoltage?: number;
  remainingCapacity?: number;
}

export interface IN2KBatteryStatus extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  voltage?: number;
  current?: number;
  temperature?: number;
}

export interface IN2KChargerStatus extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  batteryInstance?: number;
  state?: IN2KChargerState;
  mode?: IN2KChargerMode;
  enabled?: IN2KOffOn;
  equalizationPending?: IN2KOffOn;
  equalizationTimeRemaining?: number;
}

export interface IN2KCourseSpeed extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  courseReference?: IN2KDirectionReference;
  cog: number;
  sog: number;
}

export interface IN2KDSCCallInformation extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  category?: IN2KDSCCategory;
  mmsiOfShipInDistress?: number;
  latitude?: number;
  longitude?: number;
  timeOfPosition?: number;
}

export interface IN2KDepth extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  depth: number;
}

export interface IN2KDistanceLog extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  time?: string;
  log: number;
  tripLog?: number;
}

export interface IN2KEngine extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  speed: number;
}

export interface IN2KEngineDynamic extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  oilPressure?: number;
  oilTemperature?: number;
  coolantTemperature?: number;
  alternatorVoltage?: number;
  fuelRate?: number;
  engineHours?: number;
}

export interface IN2KEngineStatic extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  ratedEngineSpeed?: number;
  vin?: string;
  softwareId?: string;
}

export interface IN2KEntry {
  receivedAt: string;
  source: INMEASource;
  nmeaType: string;
  pgn: IN2KPGN;
}

export interface IN2KFluidLevel extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  type?: IN2KTankType;
  level: number;
  capacity?: number;
}

export interface IN2KHeading extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  heading: number;
  deviation?: number;
  variation?: number;
  headingReference?: IN2KDirectionReference;
}

export interface IN2KHeadingTrackControl extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  rudderLimitExceeded?: IN2KYesNo;
  offHeadingLimitExceeded?: IN2KYesNo;
  offTrackLimitExceeded?: IN2KYesNo;
  override?: IN2KYesNo;
  steeringMode?: IN2KSteeringMode;
  turnMode?: IN2KTurnMode;
  headingReference?: IN2KDirectionReference;
  commandedRudderDirection?: IN2KRudderDirection;
  commandedRudderAngle?: number;
  headingToSteerCourse?: number;
  track?: number;
  rudderLimit?: number;
  offHeadingLimit?: number;
  radiusOfTurnOrder?: number;
  rateOfTurnOrder?: number;
  offTrackLimit?: number;
  vesselHeading?: number;
}

export interface IN2KHumidity extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  actualHumidity: number;
  setHumidity?: number;
}

export interface IN2KInverterConfiguration extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  acInstance?: number;
  dcInstance?: number;
  enabled?: IN2KOffOn;
  mode?: IN2KInverterMode;
  loadSenseEnabled?: IN2KOffOn;
  loadSensePowerThreshold?: number;
  loadSenseInterval?: number;
}

export interface IN2KInverterStatus extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  acInstance?: number;
  dcInstance?: number;
  operatingState?: IN2KInverterState;
  enabled?: IN2KOffOn;
}

export interface IN2KPosition extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  latitude: number;
  longitude: number;
}

export interface IN2KRateOfTurn extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  rate?: number;
}

export interface IN2KRudder extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  directionOrder?: IN2KRudderDirection;
  angleOrder?: number;
  position?: number;
}

export interface IN2KSwitchBankStatus extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  switches: IN2KSwitchIndicator[];
}

export interface IN2KSwitchIndicator {
  index: number;
  state: IN2KOffOn;
}

export interface IN2KSystemTime extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  time: string;
}

export interface IN2KTemperatureExtended extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  temperature: number;
  setTemperature?: number;
}

export interface IN2KThrusterMotorStatus extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  identifier?: number;
  current?: number;
  temperature?: number;
  operatingTime?: number;
}

export interface IN2KTransmissionDynamic extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  gear?: IN2KGearStatus;
  oilPressure?: number;
  oilTemperature?: number;
}

export interface IN2KTripParametersEngine extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  instance?: number;
  tripFuelUsed?: number;
  fuelRateAverage?: number;
  fuelRateEconomy?: number;
  instantaneousFuelEconomy?: number;
}

export interface IN2KTripParametersVessel extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  timeToEmpty?: number;
  distanceToEmpty?: number;
  estimatedFuelRemaining?: number;
  tripRunTime?: number;
}

export interface IN2KWind extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  speed: number;
  angle: number;
  reference?: IN2KWindReference;
}

export interface IN2KWindlassMonitoringStatus extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  windlassId?: number;
  controllerVoltage?: number;
  motorCurrent?: number;
  totalMotorTime?: number;
}

export interface IN2KWindlassOperatingStatus extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  windlassId?: number;
  directionControl?: IN2KWindlassDirection;
  motionStatus?: IN2KWindlassMotion;
  rodeTypeStatus?: IN2KRodeType;
  rodeCounter?: number;
  lineSpeed?: number;
  dockingStatus?: IN2KDockingStatus;
}

export interface IN2KAlertResponse extends IN2KEntry {
  source: INMEASource;
  receivedAt: string;
  alertType?: IN2KAlertType;
  alertCategory?: IN2KAlertCategory;
  alertSystem?: number;
  alertSubSystem?: number;
  alertId?: number;
  responseCommand?: IN2KAlertResponseCommand;
}

export enum IN2KPGN {
  position = 129025,
  courseSpeed = 129026,
  vesselHeading = 127250,
  windData = 130306,
  waterDepth = 128267,
  engineRapid = 127488,
  speed = 128259,
  systemTime = 126992,
  fluidLevel = 127505,
  humidity = 130313,
  actualPressure = 130314,
  temperatureExtended = 130316,
  manOverboard = 127233,
  distanceLog = 128275,
  aisClassAPosition = 129038,
  aisClassBPosition = 129039,
  batteryStatus = 127508,
  batteryDC = 127506,
  batteryConfiguration = 127513,
  chargerStatus = 127507,
  switchBankStatus = 127501,
  engineDynamic = 127489,
  crossTrackError = 129283,
  navigationData = 129284,
  routeWaypointInformation = 129285,
  routeWaypointService = 130074,
  gnssPosition = 129029,
  gnssDOPs = 129539,
  gnssSatellitesInView = 129540,
  windlassOperatingStatus = 128777,
  windlassMonitoringStatus = 128778,
  agsConfiguration = 127512,
  agsStatus = 127514,
  engineStatic = 127498,
  aisClassAStatic = 129794,
  aisClassBStaticPartA = 129809,
  aisClassBStaticPartB = 129810,
  aisSarAircraftPosition = 129798,
  aisAddressedSafetyMessage = 129801,
  aisSafetyBroadcastMessage = 129802,
  dscCallInformation = 129808,
  alert = 126983,
  alertResponse = 126984,
  alertText = 126985,
  alertConfiguration = 126986,
  alertThreshold = 126987,
  alertValue = 126988,
  headingTrackControl = 127237,
  rudder = 127245,
  tripParametersVessel = 127496,
  tripParametersEngine = 127497,
  inverterStatus = 127509,
  inverterConfiguration = 127511,
  thrusterMotorStatus = 128008,
  rateOfTurn = 127251,
  transmissionDynamic = 127493,
}
